module.exports = __webpack_public_path__ + "static/media/IMG_3375.b7dd12b5.png";